export const REMBOURSEMENT_STATUT = {
  EFFECTUE: 'effectue',
  EN_ATTENTE: 'enAttente'
};

export const BADGE_LABEL_BY_STATUT = {
  [REMBOURSEMENT_STATUT.EFFECTUE]: 'Remboursement effectué',
  [REMBOURSEMENT_STATUT.EN_ATTENTE]: 'Dossier complet - En traitement'
};

const normalizeNom = (nom) => (nom || '').trim().toLowerCase();

export const isBeneficiaireAyantDroit = (beneficiaire, ayantDroit) =>
  normalizeNom(beneficiaire) === normalizeNom(ayantDroit);

export const getRemboursementStatut = (reglement) =>
  reglement?.dateMiseEnBanque
    ? REMBOURSEMENT_STATUT.EFFECTUE
    : REMBOURSEMENT_STATUT.EN_ATTENTE;

export const getAccountDestination = (beneficiaire, ayantDroit) =>
  isBeneficiaireAyantDroit(beneficiaire, ayantDroit)
    ? 'votre compte'
    : `le compte de ${beneficiaire}`;

// Both builders share the (dateReglement, destination) signature so they can be looked up
// interchangeably by statut; EN_ATTENTE has no settlement date yet, so it ignores its first argument.
const MESSAGE_BUILDERS = {
  [REMBOURSEMENT_STATUT.EFFECTUE]: (dateReglement, destination) =>
    `Remboursement effectué le ${dateReglement} sur ${destination}.`,
  [REMBOURSEMENT_STATUT.EN_ATTENTE]: (dateReglement, destination) =>
    `Votre dossier est en cours de traitement par nos équipes de gestion..`
};

const getMessageRemboursement = (reglement, ayantDroit, statut = getRemboursementStatut(reglement)) => {
  const destination = getAccountDestination(reglement?.beneficiaire, ayantDroit);
  return MESSAGE_BUILDERS[statut](reglement?.dateReglement?.shortDate, destination);
};

export default getMessageRemboursement;
